<template>
  <body class="printPage" ref="printPage">
    <ol class="list" v-if="list">
      <li v-for="item in list" :key="item">
        <div>
          <div class="qrcode">
            <vue-qrcode
              :value="url(item)"
              :options="{
                width: calcQRSize(),
                color: { dark: '#444' },
              }"
            ></vue-qrcode>
          </div>
          <h2>{{ item.codigo }}</h2>
          <h1>{{ item.aluno }}</h1>
          <div>
            <h3>{{ item.nomeTurma }} - {{ item.sigla }}</h3>
          </div>
        </div>
        <div class="footer">
          <h2><label>Responsável</label><span>{{ item.nome }}</span></h2>
          <h2><label>NF</label><span>{{ item.numnota }}</span></h2>
        </div>
      </li>
    </ol>
  </body>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  components: {
    VueQrcode
  },
  data () {
    return {
      list: null,
      printCount: 0
    }
  },
  mounted () {
    this.src = JSON.parse(localStorage.getItem('PrintList'))
    
    console.log("this.src:", this.src )

    document.getElementsByTagName("html")[0].style = 'height: auto !important; min-height: 100%; overflow: auto !important; background-color: #FFF !important;'
    // console.log("html:", html)
          // html.classList.add("scrollable")

    setTimeout(() => {
      if ( this.printCount === 0 ) this.print()
      this.printCount++
    },1000)
  },
  methods: {
    removeDuplicates ( data ) {
      const list =  data.filter((obj, index) => {
        return index === data.findIndex(o => obj.aluno === o.aluno)
      })

      return list
    },
    chunckList ( items, size ) {
      const chunks = []
      items = [].concat(...items)

      while (items.length) {
        chunks.push(
          items.splice(0, size)
        )
      }

      return chunks
    },
    createCode (list) {

      list.map( k => {
        console.log("list")
        const parsed = k.descricao.split(" - ")
        k['codigo'] = parsed[0]
      })

      return list
    },
    print () {
      this.list = this.createCode(this.src)

      console.log("list:", this.list)

      const newBody = this.$refs.printPage
      // console.log('newBody:', newBody)
      document.html = newBody
      // console.log(this.$refs.printPage)
      setTimeout(() => {
        // print()
      },1000)
    },
    url ( pedido ) {
      // console.log("url:", pedido)
      const { idpedidomaterial } = pedido
      const url = `${process.env.VUE_APP_APOLLO}marketplace/entregar-pedido/${idpedidomaterial}`
      console.log('url:', url)
      return url
    },
    calcQRSize () {
      const min = 200
      const max = 600
      const base = window.innerWidth / 2 
      const size = base < min ? min : ( base > max ? max : base)

      return size
    }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    display: flex;
    flex-direction: column;
    padding: 0; margin: 0 auto;

    @media print {
      display: flex; max-width: none; width: 100%;
      align-items: stretch; align-content: stretch;
      flex-wrap: wrap;
      padding: 0; margin: 0;
    }


    > li {
      display: flex; flex-direction: column;
      align-items: center; justify-content: space-between;
      list-style: none;
      padding: $mg;
      border: $border-component;
      width: 100%;
      text-align: center;
      break-inside: avoid;
      page-break-inside: avoid;
      page-break-after: always;

      &:nth-child(even) {
        border-left: 0;
      }

      .qrcode {
        border-radius: $border-radius;
        border: $border-component;
        margin: 0 auto;
        display: inline-flex;
        overflow: hidden;
      }

      >div {
        >h2 { 
          margin-top: $mg
        }
      }
      
      .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: $mg;
        width: 100%;

        >h2 {
          text-align: left;

          &:nth-child(2) {
            text-align: right;
          }

          label {
            display: block;
            // font-size: $font-size-small;
            font-weight: 400;
          }
        }
      }
    }
  }
</style>